import * as z from "zod/v4";
import { ReturnProductSchema } from "../../draft-return/draft-return-items";
import { Provider } from "../../order";
import { ShopifyGraphQLProductSchema as ProductDataSchema } from "../../product";
import { AiReturnReasonSchema } from "./return-reasons";

export const ExchangeRecommendationsSchema = z.array(
  z.object({
    product: ProductDataSchema,
    exchangeCount: z.number(),
    recommendedVariant: z
      .object({
        variantId: z.string(),
        suggestedOptions: z
          .array(z.object({ name: z.string(), values: z.array(z.string()) }))
          .optional(),
      })
      .optional(),
  }),
);

export const GenerateExchangeRecommendationsInputSchema = z.object({
  provider: z.enum(Provider),
  returnedProduct: ReturnProductSchema,
  reasons: z.array(AiReturnReasonSchema),
  aiReturnReasonsThreadId: z.string().optional(),
});

export type GenerateExchangeRecommendationsInput = z.infer<
  typeof GenerateExchangeRecommendationsInputSchema
>;

export type ExchangeRecommendations = z.infer<
  typeof ExchangeRecommendationsSchema
>;
